module.exports = __webpack_public_path__ + "img/ChaForTea.21413db5.svg";